module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloud-1-62f24d2d3334ad4328aa1bf7ad26add3.svg";